function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg086Morocco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,0 0,256 0,512 512,512 512,256 512,0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M390.587,217.82H287.772L256,120.038l-31.772,97.782H121.413l83.18,60.434l-31.773,97.784  L256,315.605l83.18,60.434l-31.773-97.784L390.587,217.82z M227.872,270.69l10.744-33.065h34.767l10.744,33.065l0,0v0.001  L256,291.125L227.872,270.69L227.872,270.69L227.872,270.69z M266.949,217.82h-21.898L256,184.122L266.949,217.82z M300.973,258.451  l-6.767-20.826h35.433L300.973,258.451z M217.794,237.624l-6.767,20.826l-28.665-20.826H217.794z M210.489,324.192l10.949-33.697  l17.716,12.871L210.489,324.192z M272.846,303.366l17.716-12.871l10.949,33.697L272.846,303.366z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg086Morocco);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHBvbHlnb24gc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIHBvaW50cz0iMCwwIDAsMjU2IDAsNTEyIDUxMiw1MTIgNTEyLDI1NiA1MTIsMCAiLz4KPHBhdGggc3R5bGU9ImZpbGw6I0ZGREE0NDsiIGQ9Ik0zOTAuNTg3LDIxNy44MkgyODcuNzcyTDI1NiwxMjAuMDM4bC0zMS43NzIsOTcuNzgySDEyMS40MTNsODMuMTgsNjAuNDM0bC0zMS43NzMsOTcuNzg0ICBMMjU2LDMxNS42MDVsODMuMTgsNjAuNDM0bC0zMS43NzMtOTcuNzg0TDM5MC41ODcsMjE3LjgyeiBNMjI3Ljg3MiwyNzAuNjlsMTAuNzQ0LTMzLjA2NWgzNC43NjdsMTAuNzQ0LDMzLjA2NWwwLDB2MC4wMDEgIEwyNTYsMjkxLjEyNUwyMjcuODcyLDI3MC42OUwyMjcuODcyLDI3MC42OUwyMjcuODcyLDI3MC42OXogTTI2Ni45NDksMjE3LjgyaC0yMS44OThMMjU2LDE4NC4xMjJMMjY2Ljk0OSwyMTcuODJ6IE0zMDAuOTczLDI1OC40NTEgIGwtNi43NjctMjAuODI2aDM1LjQzM0wzMDAuOTczLDI1OC40NTF6IE0yMTcuNzk0LDIzNy42MjRsLTYuNzY3LDIwLjgyNmwtMjguNjY1LTIwLjgyNkgyMTcuNzk0eiBNMjEwLjQ4OSwzMjQuMTkybDEwLjk0OS0zMy42OTcgIGwxNy43MTYsMTIuODcxTDIxMC40ODksMzI0LjE5MnogTTI3Mi44NDYsMzAzLjM2NmwxNy43MTYtMTIuODcxbDEwLjk0OSwzMy42OTdMMjcyLjg0NiwzMDMuMzY2eiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };